module.exports = __webpack_public_path__ + "static/media/S (207).5a281838.jpg";